import React, {Component} from 'react'
import NoSSR from 'react-no-ssr'
import Slider from 'react-slick'

const Arrow = () => (
  <svg width='16' height='10'>
    <path d='M14.008.352l1.344 1.343L7.867 9.18.383 1.695 1.727.352l6.14 6.14z' fill='#87D4F0' fillRule='evenodd' />
  </svg>
)
const NextWrapper = props => <div className='lv-next' onClick={props.go}><Arrow /></div>

const PrevWrapper = props => <div className='lv-prev' onClick={props.go}><Arrow /></div>

class Slideshow extends Component {
  constructor (props) {
    super(props)
    this.goto = this.goto.bind(this)
    this.appendDots = this.appendDots.bind(this)
    this.beforeChange = this.beforeChange.bind(this)
    this.next = this.next.bind(this)
    this.prev = this.prev.bind(this)
    this.state = { index: 0 }
  }
  beforeChange (oldIndex, newIndex) {
    this.setState({ index: newIndex })
  }
  goto (index) {
    this.slider.slickGoTo(index)
  }
  appendDots () {
    return <div>{this.props.dots(this.state.index, this.goto)}</div>
  }
  next () {
    this.slider.slickNext()
  }
  prev () {
    this.slider.slickPrev()
  }
  render () {
    const {className} = this.props
    return (
      <NoSSR>
        <Slider
          nextArrow={<NextWrapper go={this.next} />}
          prevArrow={<PrevWrapper go={this.prev} />}
          adaptiveHeight
          ref={slider => { this.slider = slider }}
          draggable={false}
          slidesToShow={1}
          slidesToScroll={1}
          speed={1000}
          autoplay
          autoplaySpeed={6000}
          infinite
          fade
          className={className}
          pauseOnDotsHover={false}
          pauseOnHover={false}
          pauseOnFocus={false}
          beforeChange={this.beforeChange}
          dots
          appendDots={this.appendDots}>{this.props.children}</Slider>
      </NoSSR>
    )
  }
}

Slideshow.defaultProps = {
  className: ''
}

export default Slideshow



// WEBPACK FOOTER //
// ./client/components/Slideshow/Slideshow.js